import {
  actionTypes,
} from 'chronos-actions';
import {
  mergeValues,
} from 'chronos-utils';


export const keyValueReducer = (
  state,
  action,
) => {
  switch (action.type) {
    case actionTypes.SET_UI_STATE:
    case actionTypes.SET_STATE: {
      const {
        keyOrRootValues,
        maybeValues,
      } = action.payload;
      const [
        values,
        key,
      ] = (
        maybeValues === undefined
          ? [
            keyOrRootValues,
            null,
          ]
          : [
            maybeValues,
            keyOrRootValues,
          ]
      );
      return {
        ...state,
        ...(
          key
            ? ({
              [key]: {
                ...state[key],
                ...mergeValues(
                  values,
                  state[key],
                ),
              },
            })
            : (
              mergeValues(
                values,
                state,
              )
            )
        ),
      };
    }
    default:
      return state;
  }
};
